/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1NotificationMobileAppNotificationid202,
  PutApiV1NotificationMobileAppNotificationid400,
  PutApiV1NotificationMobileAppNotificationid401,
  PutApiV1NotificationMobileAppNotificationid500,
  PutApiV1NotificationMobileAppNotificationidMutationRequest,
  PutApiV1NotificationMobileAppNotificationidMutationResponse,
  PutApiV1NotificationMobileAppNotificationidPathParams,
} from "../../types/notificationMobileAppController/PutApiV1NotificationMobileAppNotificationid.ts";
import { updateMobileNotificationRequestViewModelSchema } from "../updateMobileNotificationRequestViewModelSchema.ts";

export const putApiV1NotificationMobileAppNotificationidPathParamsSchema =
  z.object({
    notificationId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1NotificationMobileAppNotificationidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1NotificationMobileAppNotificationid202Schema =
  z.any() as unknown as ToZod<PutApiV1NotificationMobileAppNotificationid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1NotificationMobileAppNotificationid400Schema =
  z.any() as unknown as ToZod<PutApiV1NotificationMobileAppNotificationid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1NotificationMobileAppNotificationid401Schema =
  z.any() as unknown as ToZod<PutApiV1NotificationMobileAppNotificationid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1NotificationMobileAppNotificationid500Schema =
  z.any() as unknown as ToZod<PutApiV1NotificationMobileAppNotificationid500>;

export const putApiV1NotificationMobileAppNotificationidMutationRequestSchema =
  z.lazy(
    () => updateMobileNotificationRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1NotificationMobileAppNotificationidMutationRequest>;

export const putApiV1NotificationMobileAppNotificationidMutationResponseSchema =
  z.lazy(
    () => putApiV1NotificationMobileAppNotificationid202Schema,
  ) as unknown as ToZod<PutApiV1NotificationMobileAppNotificationidMutationResponse>;
